const DEFAULT_STORAGE_KEY = 'aivideoclip.workspace';

export function loadWorkspaceState(storageKey = DEFAULT_STORAGE_KEY) {
  try {
    const raw = localStorage.getItem(storageKey);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

export function saveWorkspaceState(partial, storageKey = DEFAULT_STORAGE_KEY) {
  const current = loadWorkspaceState(storageKey);
  localStorage.setItem(storageKey, JSON.stringify({ ...current, ...partial }));
}

export function clearWorkspaceState(storageKey = DEFAULT_STORAGE_KEY) {
  localStorage.removeItem(storageKey);
}
